const LocalStorage = {
  get: (key) => {
    const value = window.localStorage.getItem(key)
    if (value === null || value === undefined) {
      return null
    }
    try {
      return JSON.parse(value)
    } catch (error) {
      console.error('Error parsing JSON from localStorage:', error)
      return null
    }
  },
  set: (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value))
  },
  clear: () => {
    window.localStorage.clear()
  },
  delete: (key) => {
    window.localStorage.removeItem(key)
  }
}

export default LocalStorage
